// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__1RUaA","noShadow":"Loader_noShadow__1DgU6"};